module.exports = __webpack_public_path__ + "images/mobile/home/screenshot-calendar@2x-3bf26988cdab42ba7abb41b6c46c3a24.png";